import { render } from "./LocationArrowIcon.vue?vue&type=template&id=d2b3d97c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__